// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"UserDropdown-module_dropdown_PGkEL","menuList":"UserDropdown-module_menuList_3JmBx","menuSection":"UserDropdown-module_menuSection_36oPW"};